<template>
  <vs-popup :active.sync="isActive" v-esc="escape"
            :title="newVariant.id ? 'Varyant Düzenle' : rootName ? rootName + ' Altına Varyant Ekle' : 'Yeni Varyant Ekle'">
    <div class="mt-6 flex items-center justify-between px-6">
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="px-6 pt-6" @keyup.enter="submitData">

        <vs-input id="name" name="İsim" v-validate="'required|min:2|max:60'" v-model="newVariant.name" class="w-full"
                  icon-pack="feather" icon="icon-user" label-placeholder="İsim"/>
        <span class="text-danger text-sm" v-show="errors.has('İsim')">{{ errors.first("İsim") }}</span>

        <v-select id="variantType" name="Ürün Tipi" v-model="newVariant.type" :reduce="type=>type.id" itemid="id"
                  label="name" placeholder="Ürün Tipi Seçiniz" :options="variantTypes" class="mt-4" :clearable="false"
                  v-validate="'required'">
        </v-select>
        <span class="text-danger text-sm" v-show="errors.has('Ürün Tipi')">{{ errors.first('Ürün Tipi') }}</span>

        <v-select v-if="newVariant.type=='Variant'" v-validate="'required'" :disabled="sizes.length == 0" id="size"
                  name="Boy"
                  v-model="newVariant.sizeId" :reduce="size => size.id" itemid="id" label="name"
                  placeholder="Boy Seçimi"
                  :options="sizes" class="mt-4" :clearable="false"/>

        <v-select v-if="newVariant.type=='Variant'" v-validate="'required'" :disabled="recipes.length == 0" id="recipe"
                  name="Reçete"
                  v-model="newVariant.recipe" itemid="id" label="name" placeholder="Reçete Seçimi" :options="recipes"
                  class="mt-4" :clearable="false"/>

        <vs-input v-if="newVariant.type=='Variant'" id="price" name="Satış Fiyatı" v-validate="'required'"
                  v-model="newVariant.price" class="w-full" label-placeholder="Satış Fiyatı"/>
                  <label>Kdv Oranı</label>
                  <v-select v-model="newVariant.kdv" label-placeholder="Kdv Oranı" itemid="id" label="name" class="w-full"
            placeholder="Kdv Oranı" :options= kdvList  :clearable="false">
          </v-select>
        <vs-row vs-type="flex" vs-w="12" v-if="newVariant.recipe" class="mt-1">
          <vs-chip v-for="recipeStep in newVariant.recipe.recipeSteps" :key="recipeStep.id">
            {{ recipeStep.rawMaterial.name }}({{ recipeStep.unitPartQuantity }}{{ recipeStep.rawMaterial.unit.shortName }})
          </vs-chip>
        </vs-row>

        <vs-input id="variantIndex" name="Sıralama"
                  v-model="newVariant.index" class="w-full" label-placeholder="Sıralama"/>

        <vs-checkbox color="primary" class="my-2" v-model="newVariant.isDefault">Standart ?</vs-checkbox>

        <vs-textarea id="description" name="Açıklama" v-model="newVariant.description" class="w-full mt-1"
                     label="Açıklama"/>
      </div>
      <div class="flex mt-5 px-6 pb-4">
        <vs-button class="mr-auto" type="gradient" color="danger"
                   @click="newVariant = {},isActive = false;rootName = null;">
          Vazgeç
        </vs-button>
        <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
      </div>
    </VuePerfectScrollbar>
  </vs-popup>
</template>

<script>
import {
  getProductSizeList
} from "@/api/ProductSize.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  getRecipeList,
  createNewVariant,
  updateVariant,
  deleteProduct
} from "@/api/Product";
import VariantsStateTypes from "@/model/constants/VariantsStateTypes";

export default {
  data() {
    return {
      variantTypes: [{
        id: "Group",
        name: "Group"
      },
        {
          id: "Variant",
          name: "Variant"
        }
      ],
      sizes: [],
      deleteId: null,
      rootName: null,
      isActive: false,
      recipes: [],
      newVariant: {},
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      kdvList: [1,10,20],
    };
  },
  methods: {
    escape() {
      if (this.isActive == true) this.isActive = false;
    },
    getRecipeList: function (recipeId) {
      getRecipeList(recipeId).then(res => {
        if (res && res.status == 200) {
          this.recipes = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status || "",
            text: "Tarifler Yüklenemedi !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Tarifler Yüklenemedi !"
        });
      });
    },
    getSizeList: function () {
      getProductSizeList().then(res => {
        if (res && res.status == 200) {
          this.sizes = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status || "",
            text: "Boylar Yüklenemedi !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Tarifler Yüklenemedi !"
        });
      });
    },
    submitData: async function () {
      let checker;
      checker = await this.$validator.validateAll();
      if (checker) {
        this.newVariant.price = this.newVariant.price ? parseFloat(this.newVariant.price) : 0;
        this.newVariant.index = this.newVariant.index ? parseFloat(this.newVariant.index) : 0;
        if (this.newVariant.id) {
          updateVariant(this.newVariant).then(res => {
            if (res && res.status == 200) {
              this.$emit("reloadTree");
              this.isActive = false;
              this.rootName = null;
              this.newVariant = {};
              this.$validator.reset();
              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Varyant Güncelleme Başarılı !"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Varyant Güncelleme Başarısız !"
              });
            }
          }).catch(err => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası ! "
            });
          });
        } else {
          this.newVariant.id = 0;
          createNewVariant(this.newVariant).then(res => {
            if (res && res.status == 200) {
              this.$emit("reloadTree");
              this.isActive = false;
              this.rootName = null;
              this.newVariant = {};
              this.$validator.reset();
              this.$vs.notify({
                color: "success",
                title: "Başarılı !",
                text: "Varyant Ekleme Başarılı !"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Varyant Ekleme Başarısız !"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !"
            });
          });
        }
      }
    }
  },
  components: {
    VuePerfectScrollbar
  },
  watch: {
    deleteId: function (val) {
      if (val) deleteProduct(val).then(res => {
        if (res && res.status === 200) {
          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Varyant Silme Başarılı !"
          });
          this.deleteId = null;
          this.$emit("reloadTree");
        } else {
          this.$vs.notify({
            color: "success",
            title: "Hata : " + res.status,
            text: "Varyant Silme Başarısız !"
          });
        }
      }).catch(err => {
        this.$vs.notify({
          color: "success",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      });
    },
    isActive: function (val) {
      if (!val) return;
      this.getRecipeList(this.newVariant.recipe ? this.newVariant.recipe.id : null);
      this.getSizeList();
      if (Object.entries(this.newVariant).length === 1) {
        this.$validator.reset();
      } else {

        if (this.newVariant.children != null && this.newVariant.children.length > 0) {

          this.newVariant.children.forEach(item => item.state = VariantsStateTypes.Unchanged);
        }
      }
    }
  },
  mounted: function () {

  },
  created: async function () {
  }
};

</script>

<style lang="scss" scoped>
.vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  position: absolute !important;
}

.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: red;
  text-transform: lowercase;
  font-variant: small-caps;
}

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.tabPager {
  background-color: darkgreen;
  border-radius: 50%;
}

</style>
